import React from 'react';
import styled from 'styled-components';
import { Container } from '../ui';
import { StatCell } from './locationModel';
import { goldText, hairline, ink } from './tokens';

/* Ficha do local: sobe sobre a base da foto, como a placa de um empreendimento. */
const Wrap = styled(Container)`
  position: relative;
  z-index: 2;
  margin-top: -56px;

  @media (max-width: 640px) {
    margin-top: -40px;
  }
`;

const Sheet = styled.dl<{ $count: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $count }) => $count}, minmax(0, 1fr));
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 30px 60px -28px rgba(20, 12, 6, 0.35), 0 2px 6px rgba(20, 12, 6, 0.06);
  border: 1px solid ${({ theme }) => hairline(theme)};
  overflow: hidden;

  @media (max-width: 760px) {
    grid-template-columns: repeat(${({ $count }) => Math.min($count, 2)}, minmax(0, 1fr));
  }
`;

const Cell = styled.div`
  padding: 1.6rem 1.75rem 1.5rem;
  border-left: 1px solid ${({ theme }) => hairline(theme)};

  &:first-child { border-left: none; }

  @media (max-width: 760px) {
    padding: 1.2rem 1.1rem;
    border-left: none;
    border-top: 1px solid ${({ theme }) => hairline(theme)};
    &:nth-child(-n + 2) { border-top: none; }
    &:nth-child(2n) { border-left: 1px solid ${({ theme }) => hairline(theme)}; }
    &:last-child:nth-child(odd) { grid-column: 1 / -1; }
  }
`;

const Label = styled.dt`
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${({ theme }) => goldText(theme)};
`;

const Value = styled.dd`
  margin-top: 0.55rem;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-weight: 600;
  font-size: clamp(1.6rem, 3vw, 2.35rem);
  line-height: 1.05;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => ink(theme)};

  @media (max-width: 760px) {
    font-size: 1.45rem;
  }
`;

const Detail = styled.dd`
  margin-top: 0.4rem;
  font-size: 0.92rem;
  color: ${({ theme }) => theme.colors.neutral[600]};
`;

const LocationLedger: React.FC<{ cells: StatCell[] }> = ({ cells }) => {
  if (cells.length === 0) return null;
  return (
    <Wrap>
      <Sheet $count={cells.length} aria-label="Números do local">
        {cells.map((cell) => (
          <Cell key={cell.key}>
            <Label>{cell.label}</Label>
            <Value>{cell.value}</Value>
            <Detail>{cell.detail}</Detail>
          </Cell>
        ))}
      </Sheet>
    </Wrap>
  );
};

export default LocationLedger;
